
import Search from "./Search";


const index = () => {

  return (
    <div className="flex flex-col gap-4 p-3">
        {/* <div>
          <Typography
            margin={0}
            color="primary"
            fontSize={14}
            fontWeight={"bold"}
          >
            Insurance wise Oustanding report
          </Typography>
        </div> */}
        <Search/>
        {/* <Paper sx={{ width: "100%" }}>
          {isLoading ? <TableDataLoading cols={12} rows={10} /> : <ClaimList />}
        </Paper> */}

      </div>
  )
}

export default index
